import {
  POST_SEND_MAIL_SUCCESS,
  POST_SEND_MAIL_FAILURE,
} from "../constants/MyM";
import { postApi } from "../../utils/apiCall";

const postSendMailSuccess = (data) => {
  return {
    type: POST_SEND_MAIL_SUCCESS,
    payload: data,
  };
};

const postSendMailFailure = (data) => {
  return {
    type: POST_SEND_MAIL_FAILURE,
    payload: data,
  };
};

export const sendMail = (data) => {
  return async (dispatch, getState) => {
    const { error, result } = await postApi(`/send_email`, {
      ...data,
    });
    if (!error) {
      return dispatch(postSendMailSuccess(result));
    }
    return dispatch(postSendMailFailure(result));
  };
};
